import get from 'lodash/get'
import isEqual from 'lodash/isEqual'

export default (arrayFieldPath, transformationFunction) => function (value, parentVm) {
  let theOccurrence = transformationFunction(value, parentVm, this)
  let otherOccurrences = get(this, arrayFieldPath)

  let matches = otherOccurrences.filter(occurence => {
    return isEqual(occurence, theOccurrence)
  })

  return matches.length === 0
}



// WEBPACK FOOTER //
// ./src/validators/noMatchinOccurrences.js